import { render } from "./quick-guide-preview.vue?vue&type=template&id=1907a463&ts=true"
import script from "./quick-guide-preview.ts?vue&type=script&lang=ts&external"
export * from "./quick-guide-preview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__